/**
 * Created by rathompson on 9/29/22
 * File: PopoverContent
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useEffect, useRef } from 'react'
import { isElement } from '../../utils/DomUtils'

const PopoverContent = ({ children, zIndex = 1051 }) => {

  const ref = useRef()

  useEffect(() => {
    const content = ref.current
    if (isElement(content)) {
      const popover = content.closest('div:where(.panwds-tw2, .panwds-tw3) > div.tw-z-20')
      if (isElement(popover)) {
        popover.style.zIndex = zIndex
      }
    }
  }, [zIndex])

  return <div {...{ ref }}>{children}</div>
}

export default PopoverContent
